module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/2_033f97db84bea0f53dde08fdb0cf9457.png";